import React, {useState} from 'react';
import ColorPicker from './ColorPicker';

export default (props) => {
  const [products, setProducts] = useState(props.products)
  const [showModal, setShowModal] = useState(false)

  const defaultProduct = {
    type: '',
    name: '', 
    price: 0,
    colors: []
  }

  const updateProductAtIndex = (index, key, value) => {
    const temp = [...products]
    const temp_prod = {...products[index]}
    temp.splice(index, 1, {...temp_prod, [key]: value})
    setProducts(temp)
  }

  const pushNewProduct = () => {
    setProducts([...products, {...defaultProduct}])
  }

  const submitDelete = (index) => {
    const temp = [...products]
    temp.splice(index, 1)
    setProducts(temp)
  }

  const submitEdit = () => {
    props.setValue('available_products', products)
  }

  return (
    <div>
      <div className={`modal ${showModal ? 'is-active' : ''}`}>
          <div className="modal-background" onClick={() => setShowModal(false)}></div>
          <div className="modal-content">
              
          </div>
          <button className="modal-close is-large" aria-label="close" onClick={() => setShowModal(false)}></button>
      </div>
      Products:
      <div>
        {
          products.length
            ? products.map((product, i) => 
              <div 
                style={{border: `solid 5px black`, padding: '0.5rem', marginBottom: '0.5rem'}} 
              >
                <input placeholder='Product Type' className='input' value={product.type} onChange={ e => updateProductAtIndex( i, 'type', e.target.value )}/>
                <input placeholder='Product Name' className='input' value={product.name} onChange={ e => updateProductAtIndex( i, 'name', e.target.value )}/>
                <input placeholder='Price' type={'number'} className='input' value={product.price} onChange={ e => updateProductAtIndex( i, 'price', e.target.value )}/>
                <ColorPicker url={props.url} colors={product.colors} setValue={e => updateProductAtIndex(i, 'colors', e)}/>
                <div className='buttons is-right'>
                  <button className='button is-light' onClick={()=>{submitDelete()}}>Delete product</button>
                  <button className='button is-success' onClick={()=>{ submitEdit() }}>Save product</button>
                </div>
              </div>
            ) : 'No products'
        }
      </div>
      <button className='button is-info p-2' onClick={()=>{ pushNewProduct() }}>Add New Product</button>
    </div>
  )
}